import React from 'react';
import { Page } from '../../../../../shared/Components/Page';
import {TiposCambioContainer} from './Screen';

export const TiposCambioView = () =>{

    return (
        <Page title={`Tipos de Cambio (EUR / DIV)`}>{<TiposCambioContainer/>}</Page>
    )
}